import { useScroller } from "@/hooks/use-scroller";
import { useTtsModelsContext } from "@/providers/tts-models-provider/tts-models-provider";
import { useTtsVoiceCardHandler } from "@/components/pages/text-to-speech/hooks/use-tts-voice-card-handler";

export const useTtsVoiceSelect = () => {
  const { scrollY, scrollUpdate } = useScroller();

  const { models, isLoading } = useTtsModelsContext();

  const { handleTtsVoiceModelClick } = useTtsVoiceCardHandler();

  return {
    scrollY,
    handleTtsVoiceModelClick,
    scrollUpdate,
    models,
    isLoading,
  };
};
